import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styleUrls: ['./search-page.component.css']
})
export class SearchPageComponent implements OnInit {

  constructor(private router: Router) { }

  hideMeetingData = true;
  hidePastMeetingData = false;
  showMeetingMenu :boolean = true;

  ngOnInit(): void {
  }

  showMeetingTable(){
    this.hideMeetingData = true;
    this.hidePastMeetingData = false
  }

  showPastMeetingTable(){
    this.hideMeetingData = false;
    this.hidePastMeetingData = true
  }
}
